import type {ProductType} from 'nutshell-graphql-types';
import type {QuoteTerm as ProductTerm} from 'nutshell-graphql-types';

import {MAX_DESCRIPTION_LENGTH} from './product-input-fields';

export function isValidProduct(
    productName: string,
    productType: ProductType,
    productUnit: ProductTerm | null,
    productDescription?: string | null
): boolean {
    if (!productName) {
        return false;
    }

    if (productType === 'SERVICE' && !productUnit) {
        return false;
    }

    if (productDescription && productDescription.length > MAX_DESCRIPTION_LENGTH) {
        return false;
    }

    return true;
}
